import React, { useRef, useState } from 'react';
import { IncomeExpensePageShell } from './components/IncomeExpensePageShell';
import { PlaceholderTabPanel } from './components/PlaceholderTabPanel';
import ReceivableDebtSummaryTab, {
  ReceivableDebtSummaryTabHandle,
} from './components/ReceivableDebtSummaryTab';
import IncomeExpenseSummaryReportTab, {
  IncomeExpenseSummaryReportTabHandle,
} from './components/IncomeExpenseSummaryReportTab';
import IncomeExpenseBuildingLedgerDetailTab, {
  IncomeExpenseBuildingLedgerDetailTabHandle,
} from './components/IncomeExpenseBuildingLedgerDetailTab';
import IncomeExpenseCashFlowSummaryTab, {
  IncomeExpenseCashFlowSummaryTabHandle,
} from './components/IncomeExpenseCashFlowSummaryTab';
import { SUMMARY_TABS } from './tabConfigs';

const ExportIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    />
  </svg>
);

const IncomeExpenseSummaryPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('income-expense-summary');
  const receivableRef = useRef<ReceivableDebtSummaryTabHandle>(null);
  const summaryReportRef = useRef<IncomeExpenseSummaryReportTabHandle>(null);
  const ledgerDetailRef = useRef<IncomeExpenseBuildingLedgerDetailTabHandle>(null);
  const cashFlowRef = useRef<IncomeExpenseCashFlowSummaryTabHandle>(null);
  const activeConfig = SUMMARY_TABS.find((tab) => tab.id === activeTab);

  return (
    <IncomeExpensePageShell
      pageTitle={activeConfig?.label ?? 'Tổng hợp thu chi'}
      pageCode="IE_SUMMARY"
      tabs={SUMMARY_TABS.map(({ id, label }) => ({ id, label }))}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      actions={
        activeTab === 'receivable-debt' ||
        activeTab === 'income-expense-summary' ||
        activeTab === 'income-expense-cash-flow' ||
        activeTab === 'income-expense-detail'
          ? [
              {
                label: 'Xuất báo cáo',
                variant: 'success',
                icon: <ExportIcon />,
                onClick: () => {
                  if (activeTab === 'income-expense-summary') {
                    summaryReportRef.current?.exportReport();
                  } else if (activeTab === 'income-expense-cash-flow') {
                    cashFlowRef.current?.exportReport();
                  } else if (activeTab === 'income-expense-detail') {
                    ledgerDetailRef.current?.exportReport();
                  } else {
                    receivableRef.current?.exportReport();
                  }
                },
              },
            ]
          : undefined
      }
    >
      {activeTab === 'income-expense-summary' ? (
        <IncomeExpenseSummaryReportTab ref={summaryReportRef} />
      ) : activeTab === 'income-expense-cash-flow' ? (
        <IncomeExpenseCashFlowSummaryTab ref={cashFlowRef} />
      ) : activeTab === 'income-expense-detail' ? (
        <IncomeExpenseBuildingLedgerDetailTab ref={ledgerDetailRef} />
      ) : activeTab === 'receivable-debt' ? (
        <ReceivableDebtSummaryTab ref={receivableRef} />
      ) : (
        activeConfig && <PlaceholderTabPanel config={activeConfig.panel} />
      )}
    </IncomeExpensePageShell>
  );
};

export default IncomeExpenseSummaryPage;
